import {localCommand} from "../utils/api";

export const ADD_MANEUVER = 'ADD_MANEUVER';
export const MANEUVER_ADDED = 'MANEUVER_ADDED';
export const ADD_MANEUVER_FAILED = 'ADD_MANEUVER_FAILED';
export const addManeuver = localCommand('v1/maneuver/AddManeuver', ADD_MANEUVER, MANEUVER_ADDED, ADD_MANEUVER_FAILED);